import { render, staticRenderFns } from "./story_publication.vue?vue&type=template&id=604d683c&scoped=true&lang=pug"
import script from "./story_publication.vue?vue&type=script&lang=js"
export * from "./story_publication.vue?vue&type=script&lang=js"
import style0 from "./story_publication.vue?vue&type=style&index=0&id=604d683c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604d683c",
  null
  
)

export default component.exports